import { BehaviorSubject, Subject } from 'rxjs';
import { Injectable } from "@angular/core";
import { ClientType, IsUserType, ProductType, ServiceType } from "@shared/service-proxies/service-proxies";
import { ProductServiceType } from '../../../../main/products-and-services-new/products-and-services-tabs-new/product-service-status.enum';


@Injectable({
    providedIn: 'root'
})



   
export class DefaultLayoutService {
    
    isShowClientType: ClientType;
    projectSelectedHeading: any;
    clientSelectedHeading: any;
    showType: BehaviorSubject<ClientType> = new BehaviorSubject<ClientType>(null);

    userSelectedType: any;
    isShowUserType:  IsUserType.AllUsers;
    showUserType: BehaviorSubject<IsUserType.AllUsers> = new BehaviorSubject<IsUserType.AllUsers>(null);
   
    isShowProductType:  ProductType.AllProducts;
    showProductType: BehaviorSubject<ProductType.AllProducts> = new BehaviorSubject<ProductType.AllProducts>(null);
   
    isShowServiceType:  ServiceType;
    showServiceType: BehaviorSubject<ServiceType> = new BehaviorSubject<ServiceType>(null);

    isShowDashboardType: ProductServiceType;
    showDashboardType: BehaviorSubject<ProductServiceType> = new BehaviorSubject<ProductServiceType.Products>(null);


    showDashboardType1: BehaviorSubject<number> = new BehaviorSubject<number>(1);

    constructor() {

        this.showType.subscribe(res => {
            this.isShowClientType = res;
        })
        // this.showProjectType.subscribe(res => {

        this.showUserType.subscribe(res => {
            this.isShowUserType = res;
        })

        this.showProductType.subscribe(res => {
            this.isShowProductType = res;
        })
        this.showServiceType.subscribe(res => {
            this.isShowServiceType = res;
        })

        this.showDashboardType.subscribe(res => {
            this.isShowDashboardType = res;
        })

    }
    selectedTabForProject(value: number) {
        if (value === 1) {
            this.projectSelectedHeading = 'ActiveProjects';
        }
        if (value === 2) {
            this.projectSelectedHeading = 'ArchivedProjects';
        }
        if (value === 3) {
            this.projectSelectedHeading = 'DeletedProjects';
        }
    }
    selectedTabForClient(value: number) {
        if (value === 1) {
            this.clientSelectedHeading = 'ActiveClients';
        }
        if (value === 2) {
            this.clientSelectedHeading = 'ArchivedClients';
            localStorage.setItem("testArc",'true');
        }
        if (value === 3) {
            this.clientSelectedHeading = 'DeletedClients';
        }
    }
    selectedUserTab(value: number) {
        if (value === 1) {
            this.userSelectedType = 'activeUsers';
        } else if (value === 2) {
            this.userSelectedType = 'ArchivedUsers';
        } else if (value === 3) {
            this.userSelectedType = 'DeletedUsers';
        }
    }
    // showUserTypes()
    // {
    //     return this.isShowUserType;
    // }
    // setUserType() {
    //     this.showUserType.next(this.isShowUserType);
    // }


    // showClientTypes()
    // {
    //     return this.isShowClientType;
    // }
    // setClientType() {
    //     this.showClientType.next(this.isShowClientType);
    // }


    // showProductTypes()
    // {
    //     return this.isShowProductType;
    // }
    // setProductType() {
    //     this.showProductType.next(this.isShowProductType);
    // }

    // showServiceTypes()
    // {
    //     return this.isShowServiceType;
    // }
    // setServiceType() {
    //     this.showServiceType.next(this.isShowServiceType);
    // }

    /*Behavioral Subject Emit */
    CheckDashboardChange(value: any) {
        this.showDashboardType1.next(value);
    }

    getLatestValue() {
        return this.showDashboardType1.asObservable();
    }

}

// isShowClientType: ClientType;

// showType: BehaviorSubject<ClientType> = new BehaviorSubject<ClientType>(null);



// constructor() {



